<app-loading-spinner
  *ngIf="isLoading$ | async"
  [loadingTitle]="loadingTitle"
  [loadingSubtitle]="loadingSubtitle"
  [overlay]="true"
></app-loading-spinner>
<div class="row">
  <div class="col-md-8">
    <div class="modal-header">
      <span class="modal-title">{{ title }} <span *ngIf="showSecondDiv"> - {{ "global.inserie" | transloco}} </span></span>
    </div>

    <div class="modal-sub-text" *ngIf="showFirstDiv">{{ subText }}</div>
  </div>
  <div class="col-md-4 float-right">
    <button
      type="button"
      title="{{ 'modules.expert-tool.SDPs-in-Series-tooltip'
        | transloco
       }}"
      class="btn btn btn-primary"
      (click)="showSDPsInSeries()"
      *ngIf="showFirstDiv"
      >
      {{
        "modules.expert-tool.SDPs-in-Series"
        | transloco
      }}
    </button>
  </div>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <div class="vus-container">
        <ngx-datatable
          *ngIf="showFirstDiv"
          #dataTable
          class="material datatable-scrollable"
          [columnMode]="'flex'"
          [headerHeight]="56"
          rowHeight="auto"
          [scrollbarH]="false"
          [scrollbarV]="false"
          [rows]="bdpSerieFilter"
          [sorts]="sortConfig"
          [selected]="selected"
          [selectionType]="dataTableSelection"
          [selectAllRowsOnPage]="true"
          (select)="onSelect($event)"
          (sort)="onSort($event)"
        >
          <ngx-datatable-column
            [cellClass]="'text-center'"
            name=""
            prop="selected"
            [flexGrow]="0"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [width]="22"
          >
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <label class="checkradio-container">
                <input
                  type="radio"
                  [checked]="isSelected"
                  (change)="onCheckboxChangeFn($event)"
                />
                <span class="radiomark"></span>
              </label>
            </ng-template>
          </ngx-datatable-column>
          
          <ngx-datatable-column
            name="SDP"
            prop="sdpName"
            [flexGrow]="5"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              let-rowIndex="rowIndex"
              ngx-datatable-cell-template
            >
              <span
                *ngIf="value"
                class="text-pre-wrap"
                placement="bottom"
                [ngbTooltip]="value"
                data-container="body"
                container="body"
                tooltipClass="note-tooltip"
                >{{ value }}</span
              >
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort datatable-header-cell-label"
                ngbTooltip="{{ 'modules.data-management.table-header.sd-packet' | transloco: { value: value } }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{column.name}}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
                *appRequiredEntitlements="astaktEntitlement"
                name="{{ 'global.astakt' | transloco }}"
                prop="asTakt"
                [flexGrow]="2"
                [resizeable]="false"
              >
                <ng-template
                  let-value="value"
                  let-row="row"
                  ngx-datatable-cell-template
                >
                  <span *ngIf="value">{{ value }}</span>
                </ng-template>

                <ng-template
                  let-value="value"
                  let-column="column"
                  let-rowIndex="rowIndex"
                  let-sort="sortFn"
                  ngx-datatable-header-template
                >
                  <span
                    class="header-sort"
                    ngbTooltip="{{
                      'global.astakt-tooltip'
                        | transloco : { value: value }
                    }}"
                    data-container="body"
                    container="body"
                    placement="bottom"
                    tooltipClass="note-tooltip"
                    (click)="sort()"
                    >{{ column.name }}</span
                  >
                </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'global.uploaddate-AFM' | transloco }}" 
            prop="createdAt"
            [flexGrow]="4"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span *ngIf="value">{{ value | date: "dd.MM.yy HH:mm:ss" }}</span>
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort local-time-subheader"
                [attr.data-subtitle]="'global.local-time' | transloco"
                ngbTooltip="{{ 'modules.data-management.table-header.upload-date' | transloco: { value: value } }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{column.name}}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="System / User"
            prop="username"
            [flexGrow]="3"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span *ngIf="value">{{ value }}</span>
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort"
                ngbTooltip="{{ 'modules.data-management.table-header.system' | transloco: { value: value } }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{column.name}}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'modules.data-management.table-header.status' | transloco }}"
            prop="smokeTestStatus"
            [flexGrow]="5"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <div class="status-box">
                <div>
                  <span
                    [ngStyle]="{'color': getColor(value)}"
                  >
                    <i class="bi bi-circle-fill"></i>
                  </span>
                </div>
                <div class="status-text" *ngIf="value">{{ getValue(value) }}</div>
              </div>
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort"
                ngbTooltip="{{ 'modules.data-management.table-header.status' | transloco: { value: value } }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{column.name}}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
          name="{{ 'global.bdp-status.title' | transloco }}"
          prop="bdpStatus"
          [flexGrow]="3"
          [resizeable]="false"
        >
          <ng-template
            let-value="value"
            let-column="column"
            let-rowIndex="rowIndex"
            let-sort="sortFn"
            ngx-datatable-header-template
          >
            <span
              class="header-sort"
              ngbTooltip="{{
                'global.bdp-status.tooltip' | transloco: { value: value }
              }}"
              data-container="body"
              container="body"
              placement="bottom"
              tooltipClass="note-tooltip"
              (click)="sort()"
              >{{ column.name }}</span
            >
          </ng-template>

          <ng-template
            let-value="value"
            let-row="row"
            ngx-datatable-cell-template
          >
            <div class="status-box">
              <div class="status-text" *ngIf="value">{{ getBDPValue(value) }}</div>
            </div>
          </ng-template>
        </ngx-datatable-column>
        </ngx-datatable>
        
        <ngx-datatable
          *ngIf="showSecondDiv"
          #dataTable
          class="material datatable-scrollable"
          [columnMode]="'flex'"
          [headerHeight]="56"
          rowHeight="auto"
          [scrollbarH]="false"
          [scrollbarV]="false"
          [selected]="selected"
          [selectionType]="dataTableSelection"
          (select)="onSelect2($event)"
          [rows]="seriesHistory"
        >
        <ngx-datatable-column
            [cellClass]="'text-center'"
            name=""
            prop="selected"
            [flexGrow]="0"
            [sortable]="false"
            [canAutoResize]="false"
            [draggable]="false"
            [resizeable]="false"
            [width]="22"
          >
            <ng-template
              ngx-datatable-cell-template
              let-value="value"
              let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn"
            >
              <label class="checkradio-container">
                <input
                  type="radio"
                  [checked]="isSelected"
                  (change)="onCheckboxChangeFn($event)"
                />
                <span class="radiomark"></span>
              </label>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column
            name="{{ 'global.sd-packet' | transloco }}"
            prop="name"
            [flexGrow]="7"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              let-rowIndex="rowIndex"
              ngx-datatable-cell-template
            >
              <span
                *ngIf="value"
                placement="bottom"
                data-container="body"
                container="body"
                tooltipClass="note-tooltip"
                >{{ value }}</span
              >
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort datatable-header-cell-label"
                ngbTooltip="{{
                  'modules.data-management.table-header.sd-packet'
                    | transloco : { value: value }
                }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{ column.name }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            *appRequiredEntitlements="astaktEntitlement"
            name="{{ 'global.astakt' | transloco }}"
            prop="asTakt"
            [flexGrow]="4"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span
                *ngIf="value">{{ value }}</span>
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort"
                ngbTooltip="{{
                  'global.astakt-tooltip'
                    | transloco : { value: value }
                }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{ column.name }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'global.uploaddate-AFM' | transloco }}"
            prop="createdAt"
            [flexGrow]="6"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span *ngIf="value">{{ value | date : "dd.MM.yy HH:mm:ss" }}</span>
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort local-time-subheader"
                [attr.data-subtitle]="'global.local-time' | transloco"
                ngbTooltip="{{
                  'modules.data-management.table-header.upload-date'
                    | transloco : { value: value }
                }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{ column.name }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            [cellClass]="'text-right'"
            name="User"
            prop="username"
            [flexGrow]="5"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span *ngIf="value">{{ value }}</span>
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort"
                ngbTooltip="{{
                  'modules.data-management.table-header.system'
                    | transloco : { value: value }
                }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{ column.name }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'modules.data-management.table-header.status' | transloco }}"
            prop="status"
            [flexGrow]="6"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort"
                ngbTooltip="{{
                  'modules.data-management.table-header.status'
                    | transloco : { value: value }
                }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{ column.name }}</span
              >
            </ng-template>

            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <div class="status-box" *ngIf="value">
                <div>
                  <span
                    [ngStyle]="{'color': getColor(value)}"
                  >
                    <i class="bi bi-circle-fill"></i>
                  </span>
                </div>
                <div class="status-text">
                  {{ getValue(value) }}
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'global.productive-from' | transloco }}"
            prop="inSeriesSince"
            [flexGrow]="5"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span *ngIf="value">{{
                value | date : "dd.MM.yy HH:mm:ss"
              }}</span>
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort  local-time-subheader"
                [attr.data-subtitle]="'global.local-time' | transloco"
                ngbTooltip="{{
                  'global.productive-from' | transloco : { value: value }
                }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{ column.name }}</span
              >
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column
            name="{{ 'global.productive-until' | transloco }}"
            prop="inSerieUntil"
            [flexGrow]="5"
            [resizeable]="false"
          >
            <ng-template
              let-value="value"
              let-row="row"
              ngx-datatable-cell-template
            >
              <span *ngIf="value">{{
                value | date : "dd.MM.yy HH:mm:ss"
              }}</span>
            </ng-template>

            <ng-template
              let-value="value"
              let-column="column"
              let-rowIndex="rowIndex"
              let-sort="sortFn"
              ngx-datatable-header-template
            >
              <span
                class="header-sort local-time-subheader"
                [attr.data-subtitle]="'global.local-time' | transloco"
                ngbTooltip="{{
                  'global.productive-until' | transloco : { value: value }
                }}"
                data-container="body"
                container="body"
                placement="bottom"
                tooltipClass="note-tooltip"
                (click)="sort()"
                >{{ column.name }}</span
              >
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="button-area float-end">
          <div class="displayed">
            <button type="button" class="btn btn-secondary" (click)="cancel()">
              <span *ngIf="showFirstDiv">
                {{ 'global.cancel' | transloco }}
              </span>
              <span *ngIf="showSecondDiv">
                {{ 'global.back' | transloco }}
              </span>
            </button>
            <button type="button" class="btn btn-primary" (click)="save()" *ngIf="showFirstDiv || showSecondDiv">
              {{ 'modules.expert-tool.btn-choose-packet' | transloco }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
